import { render, staticRenderFns } from "./agreement.html?vue&type=template&id=3ff5fd20&scoped=true&"
import script from "./agreement.js?vue&type=script&lang=js&"
export * from "./agreement.js?vue&type=script&lang=js&"
import style0 from "./agreement.scss?vue&type=style&index=0&id=3ff5fd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5fd20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff5fd20')) {
      api.createRecord('3ff5fd20', component.options)
    } else {
      api.reload('3ff5fd20', component.options)
    }
    module.hot.accept("./agreement.html?vue&type=template&id=3ff5fd20&scoped=true&", function () {
      api.rerender('3ff5fd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/easycash-indo/webview/lender/sign-up/component/agreement/agreement.vue"
export default component.exports